import ObjectID from 'bson-objectid';

const USER_PSEUDO_ID_KEY = 'user_pseudo_id';

const generatePseudoId = () => {
  const id = new ObjectID().toHexString();

  window.localStorage.setItem(USER_PSEUDO_ID_KEY, id);

  return id;
};

export const getOrGenerateUserPseudoId = () => {
  const savedUserPseudoId = window.localStorage.getItem(USER_PSEUDO_ID_KEY);

  if (typeof savedUserPseudoId === 'string' && savedUserPseudoId.length > 0) {
    return savedUserPseudoId;
  } else {
    console.warn("There is saved user_pseudo_id but it's ivalid");
  }

  console.warn('There is no api token, going to generate pseudo id...');

  return generatePseudoId();
};
